<template>
  <div class="checkout-overlay-check">
    <input type="checkbox" :value="inputValue" :id="id" @change="emitInputValue">
    <label :for="id" class="checkout-overlay-check-fake-input"></label>
    <label :for="id" class="checkout-overlay-check-label"><slot /></label>
  </div>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-check {
    display: flex;
    height: 100%;
  }

  input {
    height: 0;
    width: 0;
    pointer-events: none;
    opacity: 0;

    &:checked + .checkout-overlay-check-fake-input {
      &:before {
        opacity: 1;
      }
    }
  }

  .checkout-overlay-check-fake-input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    width: 20px;
    height: 20px;
    border: 1px solid #fff;
    border-radius: 2px;
    margin: auto;

    &:before {
      content: '';
      width: 8px;
      height: 8px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      background: #fff;
      opacity: 0;
    }
  }

  .checkout-overlay-check-label {
    padding: 10px 18px 10px 50px;
    display: flex;
    height: 100%;
    flex: 1;
    align-items: center;
    cursor: pointer;
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-check',
    props: {
      id: Number,
      inputValue: [Number, String],
      value: Array
    },
    methods: {
      emitInputValue ($event) {
        let currentValue = this.value
        const inputValue = $event.target.value

        if (currentValue.indexOf(inputValue) === -1) {
          currentValue.push(inputValue)
        } else {
          currentValue.splice(currentValue.indexOf(inputValue), 1)
        }

        this.$emit('input', currentValue)
      }
    }
  }
</script>
